<!-- Verbatim Grid -->
<div class="verbatimContainer">
    <div class="ltms-description mt-3">
        <span class="custom-description">
            {{desclaimer}}
        </span>
        <div class="litmus-button-group" *ngIf="!isAccountLevel && isReportDownloadAllowed">
            <button (click)="openADRModal()">
                <img src="assets/images/download-2.svg" />
            </button>
        </div>
    </div>
    <div #target id="verbatimCard_{{pageNumber}}">
        <div class="row" *ngIf="!pagerBusy && feedChunks.length">
            <div class="column" *ngFor="let chuck of feedChunks; let ind = index">
                <div class="card" *ngFor="let feed of chuck; let i = index">
                    <div class="card-container" 
                    [style.background]="getEmoticonImageUrl(feed)" 
                    [style.background-repeat]="'no-repeat'"
                    [style.background-position]="'right bottom'">
                        <ng-container *ngIf="feed && feed['color'] && feed['color']['color']">
                            <span class="verbatim-card-header-rating-text" [ngStyle]="{'background': feed['color']['color']}">
                                <ng-container *ngIf="feed.feed_params && feed.feed_params.primary_rating != null">
                                    {{ feed.feed_params.primary_rating}}
                                </ng-container>
                            </span>
                        </ng-container>
                        <p class="verbatim-comment-text" *ngIf="feed && feed.feed_params && feed.feed_params.comments">&#x201C;{{feed.feed_params.comments}}&#x201D;</p>
                        <div class="verbatim-detail-section">
                            <span>
                                <span class="verbatim-private-user-name">
                                    <span *ngIf="feed.isTokenisedProject">
                                        {{"ANONYMOUS" | translate}}
                                    </span>
                                    <span *ngIf="!feed.isTokenisedProject">
                                        {{feed["feedback_request_data"]["tag_private_user_name"] || 'NA'}}
                                    </span>
                                </span>
                                <span class="collapsable-icon" *ngIf="feed.readMore == false" (click)="toggelDetails(true, ind, i)" ><img src="assets/images/chevron-down-arrow.svg" /></span>
                                <span class="collapsable-icon" *ngIf="feed.readMore == true" (click)="toggelDetails(false, ind, i)"><img src="assets/images/chevron-up-arrow.svg" /></span>
                                <span class="open-in-new-icon" (click)="openFeed(feed)"><img src="assets/images/open_in_new.png" /></span>
                            </span>
                        </div>
                    </div>
                    <table class="table colapsable-details" id="collapseVerbatim_{{feed._id}}" [style.display]="feed.readMore? 'block': 'none'">
                        <tbody>
                            <tr>
                                <td>{{"RECEEVED_ON" | translate}}:</td>
                                <td>{{feed.created_date }}</td>
                            </tr>
                            <tr>
                                <td>{{"REQUESTED_ON" | translate}}:</td>
                                <td>{{feed.feedback_request_date}}</td>
                            </tr>
                            <tr>
                                <td>{{"ASSIGNEE" | translate}}:</td>
                                <td>{{feed.assignee || 'NA'}}</td>
                            </tr>
                            <ng-container *ngIf="(feed.transactionalData | json) != '{}'">
                                <tr *ngFor="let field of feed.transactionalData | keyvalue;">
                                    <td *ngIf="field.value">{{field.key}}:</td>
                                    <td *ngIf="field.value">{{field.value}}</td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="load-more" *ngIf="feedChunks && feedChunks.length > 0 && !pagerBusy">
        <br>
        <button *ngIf="loadMore" type="button" class="btn btn-default" (click)="loadMoreFeeds(target)">{{loadMoreResponse}}</button>
        <button *ngIf="!loadMore" type="button" class="btn btn-default no-more-data">{{noMoreResponse}}</button>
    </div>
    <div *ngIf="!feedChunks.length && !pagerBusy">
        <app-ltms-error [code]="errorCode"></app-ltms-error>
    </div>
    <div id="loading" *ngIf="pagerBusy">
        <app-ltms-loader></app-ltms-loader>
    </div>
</div>
<app-feed-detail-panel (onPageChange)="onPageChange($event)"></app-feed-detail-panel>
<litmus-response-downloader *ngIf="isADRMOdalOpen" [brandDetails]="brandDetails" [filters]="filters"
    [paginationDetail]="pagingDetails" (onClose)="closeADRModal()"></litmus-response-downloader>